import Head from "next/head";

export default function FaqPage() {
  return (
    <div className="container d-flex flex-grow-1">
      <Head>
        <title>คำถามที่พบบ่อย | {process.env.appName}</title>
        <meta
          name="description"
          content={`คำถามที่พบบ่อย | ${process.env.appName}`}
        />
        <meta
          name="og:title"
          content={`คำถามที่พบบ่อย | ${process.env.appName}`}
        />
        <meta
          name="og:description"
          content={`คำถามที่พบบ่อย | ${process.env.appName}`}
        />
      </Head>
      <main className="w-100">
        <div className="mt-2 mb-1 card">
          <div className="px-4 py-2 my-2">
            <h1 className="h4">คำถามที่พบบ่อย (FAQ)</h1>
            <ul
              className="mt-2 mb-2 list-group list-group-flush"
              id="info-accordion"
            >
              <li className="list-group-item border-top">
                <h2 className="h5">CanCount มีค่าใช้จ่ายหรือไม่</h2>
                <p>คุณสามารถใช้ CanCount ได้ฟรีและไม่จำกัดจำนวนครั้ง</p>
              </li>
              <li className="list-group-item">
                <p className="h5">CanCount ใช้งานได้กับภาษาอะไรบ้าง</p>
                <p>CanCount สามารถนับจำนวนคำได้ทั้งภาษาไทยและภาษาอังกฤษ</p>
              </li>
              <li className="list-group-item">
                <p className="h5">CanCount เก็บข้อมูลของคุณหรือไม่</p>
                <p>
                  CanCount มีการใช้งาน Google Analytics และ Google Analytics for
                  Firebase เพื่อเก็บสถิติและวิเคราะห์พฤติกรรมผู้ใช้ แต่ CanCount
                  จะไม่มีการเก็บข้อมูลคอนเทนต์ที่ผู้ใช้งานป้อนเข้าสู่กล่องอินพุต
                  ข้อมูลคอนเทนต์ของผู้ใช้จะประมวลผลบนเครื่องของท่านโดยไม่มีการส่งกลับมาที่เซิร์ฟเวอร์ของทาง
                  CanCount แต่อย่างใด
                </p>
              </li>
              <li className="list-group-item">
                <p className="h5">
                  ทำไม CanCount โหลดช้าในการเข้าใช้งานครั้งแรก
                </p>
                <p className="m-0">
                  ในการใช้งานครั้งแรก CanCount
                  มีการโหลดพจนานุกรมสำหรับช่วยในการนับจำนวนคำซึ่งจะส่งผลให้ในการใช้งานครั้งแรกจะช้ากว่าปกติ
                </p>
              </li>
            </ul>
          </div>
        </div>
      </main>
    </div>
  );
}
